<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <div class="fill-height">
        <md-table
          v-model="notifications"
          md-sort="sent"
          md-sort-order="desc"
          @md-selected="view"
          md-card
          md-fixed-header
        >
          <md-table-toolbar>
            <div class="md-toolbar-section-start">
              <h1 class="md-title">{{ title }}</h1>
            </div>

            <div class="md-toolbar-section-end">
              <md-field md-clearable>
                <md-input placeholder="Search inbox ..." v-model="search" @input="doFilter" />
              </md-field>
            </div>
          </md-table-toolbar>

          <md-table-empty-state
            md-label="No notifications found"
            :md-description="`No notifications found for this '${search}' query. Try a different search term.`"
          ></md-table-empty-state>

          <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
            <md-table-cell md-label="To" md-sort-by="to">{{ item | displayMethod }}</md-table-cell>
            <md-table-cell md-label="Subject" md-sort-by="title">{{ item.template.title }}</md-table-cell>
            <md-table-cell md-label="Sent Date" md-sort-by="sent">{{ item.sent_dt | formatDate }}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "NotificationsList",
  props: {
    notifications: Array,
    detailLink: String,
    title: String,
    user: Object
  },
  methods: {
    doFilter: function() {
      this.$emit("filter", this.search);
    },
    view: function(notification) {
      this.$router.push(`${this.detailLink}/${notification.message_id}`);
    }
  },
  data: function() {
    return {
      search: null
    };
  },
  filters: {
    count: function(value) {
      if (value) return value.length;
      else return 0;
    },
    formatDate: function(value) {
      if (value) {
        let m = moment(value);
        if (m.isSame(moment(), "day")) {
          return m.format("h:mm A");
        } else if (m.isSame(moment(), "year")) {
          return m.format("MMM D");
        } else {
          return m.format("M/D/YY");
        }
      } else return "";
    },
    displayMethod: function(value) {
      if (value) {
        if (value.assignment.delivery_method == "email") {
          return value.user.email;
        } else {
          return "";
        }
      } else return "";
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
